import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../views/layout'
const defaultLayout = {render(){return (<router-view />)}}

Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/vat_centre',
      component: Layout,
      alwaysShow: true,
      meta: {
        icon: 'u738',
        title: 'VAT中心',
      },
      children: [
      {
        path: 'service',
        name: 'VatCentre_Service',
        component: () => import('@/views/vat_centre/service'),
        meta: {
          title: '我的服务'
        }
      },
      {
        path: 'declare',
        name: 'VatCentre_Declare',
        component: () => import('@/views/vat_centre/declare'),
        meta: {
          title: '我的申报'
        }
      },
      {
        path: 'calculate',
        name: 'VatCentre_Calculate',
        component: () => import('@/views/vat_centre/calculate'),
        meta: {
          title: '税金试算'
        }
      },
      {
        path: 'outstanding',
        name: 'VatCentre_Outstanding',
        component: () => import('@/views/vat_centre/outstanding'),
        meta: {
          title: '欠税监控'
        }
      }]
    },
    {
      path: '/login',
      component: () => import('@/views/login/index'),
      hidden: true
    },
    {
      path: '/icons',
      component: () => import('@/views/icons'),
      hidden: true
    },
    {
      path: '/purchase/:id',
      name: 'Purchase',
      component: () => import('@/views/purchase/index.vue'),
      hidden: true
    },
    {
      path: '*',
      redirect: { name: 'VatCentre_Service' },
      hidden: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js